module.exports = __webpack_public_path__ + "static/media/cancelled.f61f4e3c.svg";